import { prefersReducedMotion, saveData } from "../utilities"

export default class {
  constructor(el, options) {
    try {
      const playButtonEl = el.querySelector(".js-videoPlay")
      const posterPlayButtonEl = el.querySelector(".js-videoPosterPlay")
      const videoPosterEl = el.querySelector("video.js-videoPoster")

      function onClickPlay(e) {
        e.preventDefault()

        if (posterPlayButtonEl) {
          if (e.target === posterPlayButtonEl) {
            return
          }

          posterPlayButtonEl.parentNode.removeChild(posterPlayButtonEl)
        }

        const iframeEl = document.createElement("iframe")
        iframeEl.setAttribute("src", options.src)
        iframeEl.setAttribute("width", options.width ?? "100%")
        iframeEl.setAttribute("height", options.width ?? "100%")
        iframeEl.setAttribute("allowfullscreen", "")
        iframeEl.setAttribute("allow", "autoplay;fullscreen;encrypted-media;")
        iframeEl.setAttribute("disablePictureInPicture", true)

        el.appendChild(iframeEl)

        el.classList.add("is-active")

        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        })
      }

      if (options.fullclick) {
        el.addEventListener("click", onClickPlay, {
          once: true,
        })
      } else if (playButtonEl) {
        playButtonEl.addEventListener("click", onClickPlay, {
          once: true,
        })
      }

      if (videoPosterEl) {
        if (prefersReducedMotion || saveData) {
          videoPosterEl.parentNode.removeChild(videoPosterEl)
          if (posterPlayButtonEl) {
            posterPlayButtonEl.parentNode.removeChild(posterPlayButtonEl)
          }

          return
        }

        videoPosterEl.style.opacity = 0

        videoPosterEl.addEventListener(
          "play",
          function () {
            try {
              const playPromise = videoPosterEl.play()

              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    if (posterPlayButtonEl) {
                      posterPlayButtonEl
                        .querySelector("use")
                        .setAttribute("xlink:href", "#symbol-pause")
                    }
                  })
                  .catch((error) => {
                    console.error(1, error)
                    // videoPosterEl.parentNode.removeChild(videoPosterEl)
                  })
              }

              videoPosterEl.style.opacity = 1
            } catch (err) {
              console.error(2, err)
              videoPosterEl.style.opacity = 1
            }
          },
          false,
        )

        if (posterPlayButtonEl) {
          videoPosterEl.addEventListener(
            "pause",
            function () {
              posterPlayButtonEl
                .querySelector("use")
                .setAttribute("xlink:href", "#symbol-play")
            },
            false,
          )
        }

        if (options.autoplay !== "false") {
          videoPosterEl.play()
        }

        if (posterPlayButtonEl) {
          posterPlayButtonEl.addEventListener(
            "click",
            function (e) {
              e.preventDefault()

              if (videoPosterEl.paused) {
                videoPosterEl.play()
              } else {
                videoPosterEl.pause()
              }

              localStorage.setItem(
                "videoPosterPause",
                videoPosterEl.paused ? "true" : "false",
              )
            },
            true,
          )
        }
      }
    } catch (err) {
      console.error(err)
    }
  }
}
